function testimonialsSlider() {
  $(document).ready(function() {
    if ($('.testimonials-container').length) {
      var testimonialsSlider = new Splide('#testimonials-container', {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        focus: 1,
        autoplay: true,
        arrows: true,
        pagination: false,
        fixedWidth : '25rem',
        gap: '1.5rem',

        breakpoints: {
          680: {
            perPage: 1,
            perMove: 1,
            focus: 'center',
            fixedWidth : false,
            gap: 0,
          },
          991: {
            perPage: 2,
            perMove: 1,
            focus: 1,
            fixedWidth : false,
          },
          1024: {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            focus: 1,
            autoplay: true,
            arrows: true,
            pagination: false,
            fixedWidth : '25rem',
            gap: '1.5rem',
          }
        }

      });

      testimonialsSlider.mount();
    }
  });
}
